import { useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import BackEndService from '../../api/BackEndService';
import { DeleteIcon } from '../../icons/DeleteIcon/DeleteIcon';
import { productManagementActions } from '../../store/product-management-slice';
import { CustomButton } from '../CustomButton/CustomButton';
import { DeleteDocumentModal } from '../DeleteDocumentModal/DeleteDocumentModal';

import styles from './addProductModalTabs.module.css';
import DocumentIcon from './document.svg';
import { Column, Table } from './Table';

const formatFileSize = (bytes: number | undefined) => {
    if (bytes === undefined || bytes === null) return "";

    const megabytes = bytes / (1024 * 1024);

    return megabytes >= 1
        ? `${parseFloat(megabytes.toFixed(2))} MB`
        : `${parseFloat((bytes / 1024).toFixed(2))} KB`;
};

// A pending upload (not saved yet) has a File and `size`; a stored document has `fileSize`, its
// upload date and a url.
const renderDocumentName = (row: any) => <div className={styles.documentNameContainer}>
    <img src={DocumentIcon} />
    <div className={styles.documentName}>
        <p className={styles.documentName__name}>
            <a href={row.previewUrl ?? row.url} target="_blank" rel="noreferrer">{row.name ?? row.fileName}</a>
        </p>
        <p className={styles.documentName__info}><span>{formatFileSize(row.size ?? row.fileSize)}</span><span>{new Date(row.createdAt ?? Date.now()).toLocaleDateString("de-DE")}</span></p>
    </div>
</div>

export const DokumenteTab = () => {
    const dispatch = useDispatch();
    const documents = useSelector((state: any) => state.productManagement.temporaryDocuments);
    const includeDocuments = useSelector((state: any) => state.productManagement.documents);
    const fileInputRef = useRef<HTMLInputElement>(null);
    const [isOpen, setIsOpen] = useState(false);
    const [documentToDelete, setDocumentToDelete] = useState<string | null>(null);
    const [isIncludeDocument, setIsIncludeDocument] = useState(false);
    const [isDeleting, setIsDeleting] = useState(false);

    const columns: Column<any>[] = [
        {
            key: "name",
            label: "Dokument name",
            render: (_, row) => renderDocumentName(row)
        },
        {
            key: "delete",
            label: "",
            render: (_, row) => <DeleteIcon color='outlined' height={16} onClick={() => {
                setIsIncludeDocument(Boolean(row.attachedTo?.id));
                setDocumentToDelete(row.id);
                setIsOpen(true);
            }} />
        }
    ];

    const handleUploadClick = () => {
        fileInputRef.current?.click();
    };

    const handleFileChange = (
        event: React.ChangeEvent<HTMLInputElement>
    ) => {
        const files = event.target.files;

        if (!files || files.length === 0) {
            return;
        }

        Array.from(files).forEach((file) => {
            const document = {
                id: crypto.randomUUID(),
                file,
                name: file.name,
                size: file.size,
                type: file.type,
                previewUrl: URL.createObjectURL(file),
            };

            dispatch(
                productManagementActions.addDocument(document)
            );
        });

        // Lets the same file be picked again after it was removed from the list.
        event.target.value = "";
    };

    const removeDocument = async (id: string) => {
        if (isIncludeDocument) {
            setIsDeleting(true);
            try {
                await BackEndService.DeleteDocument(id);
                dispatch(productManagementActions.removeIncludeDocument(id));
            } catch (error) {
                console.error(error);
            } finally {
                setIsDeleting(false);
            }

        } else
            dispatch(productManagementActions.removeDocument(id));

        setIsOpen(false);
        setDocumentToDelete(null);
        setIsIncludeDocument(false);
    }

    return <div className={styles["tab-zubehor"]}>
        <div className={styles["tab-zubehor-header"]}>
            <div></div>
            <CustomButton onClick={handleUploadClick} color='lightGreenNew' icon='upload' iconPosition='left' customClass={styles["zubehor-tab-bearbeiten-button"]}>Hochladen</CustomButton>
            <input
                ref={fileInputRef}
                type="file"
                multiple
                hidden
                onChange={handleFileChange}
            />
        </div>
        <Table data={[...documents, ...includeDocuments]} columns={columns} isDocument={true} empty={{ title: 'Keine hochgeladenen Dokumente', text: 'Klicken Sie auf „Hochladen“, um relevante Dokumente für diesen Artikel hinzuzufügen.' }} />
        <DeleteDocumentModal isDeleting={isDeleting} isOpen={isOpen} onClose={() => setIsOpen(false)} onDelete={() => {
            if (documentToDelete)
                removeDocument(documentToDelete);
        }} />
    </div>;
};